import { Button, Container } from 'react-bootstrap';
import { Logo } from '../Logo/Logo';
import styles from './Footer.module.scss';
import { AppDownload } from '../AppDownload/AppDownload';
import { useEffect, useState } from 'react';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useMobileDetect } from '../../../hooks/useMobileDetect';
import { Legalese } from '../Legalese/Legalese';
import { useTranslation } from 'react-i18next';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { isItalian } from '../../utils/utils';
import { useGeolocation } from '../../../contexts/GeolocationContext';

const FooterComponent = () => {
  const [suggestApp, setSuggestApp] = useState(false);
  const { isNative } = useCapacitor();
  const { isMobile } = useMobileDetect();
  const { t } = useTranslation();
  const { staticData } = useFirebase();
  const { country_code } = useGeolocation();

  useEffect(() => {
    setSuggestApp(isMobile && !isNative);
  }, [isMobile, isNative]);

  if (isNative) return null;

  return (
    <div className={`bottom-footer`}>
      <Container>
        <div className={`d-flex justify-content-center align-items-center flex-wrap ${styles.footerRow}`}>
          <Logo className={`${styles.logoTootor} mr-3`} variant={'light'} />
          <div className={`d-flex flex-wrap align-items-center ${styles.footerActions}`}>
            <Button size={'sm'} className="tootor-button tootor-button--primary" href={'/help'}>
              {t('labels.helpCenter')}
            </Button>
            {staticData.SHOW_COLLABORATE && (
              <Button size={'sm'} className="tootor-button tootor-button--basic" href={'/collaborate'}>
                {t('labels.lavoraConNoi')}
              </Button>
            )}
            {!isNative && staticData.ENABLE_GIFTS && isItalian(country_code) && (
              <Button size={'sm'} className="tootor-button tootor-button--basic" href={'/gift'}>
                {t('labels.regalaAbbonamento')}
              </Button>
            )}
          </div>
        </div>
        <small className={`text-muted d-flex flex-wrap ${styles.footerLegalese}`}>
          <Legalese />
        </small>
        {isMobile && !isNative && (
          <div className={'mt-2'}>
            <AppDownload className={'d-flex justify-content-center align-items-center'} />
          </div>
        )}
      </Container>
    </div>
  );
};

export { FooterComponent as Footer };
